export interface PriceAttribute{
    id?: number;
    type?: string;
    amount: number | null;
    amountDds: number | null;
    ddsValue: number | null;
    kind?: string;
    // discountValue?: number;
}


export enum PRICE_ATTRIBUTE_TYPE {
    DISCOUNT = 'discount',
    PRICE = 'price'
}